import { loginAPI } from '../services/Login/loginAPI.js';
import { ConfigStore } from "./Config/config.store.js";

const LoginStore = {
    namespaced: true,
    state: {
        token: undefined
    },
    mutations: {
        SET_TOKEN(state, payload) {
            state.token = payload;
        }
    },
    actions: {
        doLoginAPI: async function({ commit }) {
            const response = await loginAPI(
                `${process.env.VUE_APP_API_URL}${ConfigStore.state.endpoints.loginAPI}`, // url
                process.env.VUE_APP_API_USERNAME,
                process.env.VUE_APP_API_PASSWORD,
            );
            if (response.status === 200) {
                commit("SET_TOKEN", response.data.access_token);
            }
            return response;
        }
    },
    getters: {
        getToken(state) {
            return state.token;
        },
    },
};
export { LoginStore };